import {Directive, ElementRef, HostListener, Input} from '@angular/core';
import {TimelineService} from '../../timeline.service';
import {DragService} from "../../../../shared/drag.service";

@Directive({
  selector: '[appTimelineDrag]'
})
export class TimelineDragDirective {

  @Input() clipsElementRef;
  @Input() layers;

  constructor(public element: ElementRef, private dragService: DragService, private timelineService: TimelineService) { }

  @HostListener('touchend', ['$event'])
  @HostListener('document:mouseup', ['$event'])
  onMouseup(event) {
    event.stopPropagation();

    this.dragService.onDragMouseUp.next(event);

    event.preventDefault();
  }

  @HostListener('touchstart', ['$event'])
  @HostListener('mousedown', ['$event'])
  onMousedown(event: MouseEvent) {
    event.stopPropagation();

    if (!this.timelineService.isScrollEnabled()) {
      return false;
    }

    const dragStartPosition = {x: DragService.getClientXFromEvent(event), y: DragService.getClientYFromEvent(event),
      element: {x: this.elPos().left || 0, y: this.elPos().top || 0}};

    const elements = this.collectLayerElements();
    this.dragService.setDragElement(elements, dragStartPosition, DragService.DRAG_TYPE.TIMELINE_MOVE);

    this.dragService.setMouseDown((ev) => {

    });

    this.dragService.onDragMouseDown.next(event);
    event.preventDefault();
  }

  collectLayerElements() {
    const elements = [];
    for (let i = 0; i < this.layers.length; i++) {
      elements.push(this.layers[i].getElementRef());
    }

    return elements;
  }

  elPos() {
    return {
      top: parseInt(this.clipsElementRef.nativeElement.style.top, 10),
      left: parseInt(this.clipsElementRef.nativeElement.style.left, 10)
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-edit/timeline/video-layer/directives/timeline-drag.directive.ts